@let paymentState = $paymentState();
@if (paymentState === undefined) {
    <cm-placeholder [dark]="true" format="rect"></cm-placeholder>
} @else if (paymentState !== null) {
    <cm-state-label [stateLabels]="Labels.PaymentState" [state]="paymentState" [editable]="true" (stateChange)="stateChange.emit($event)"> </cm-state-label>
}
